/**
 * Pins the column that identifies the row, for narrow screens.
 *
 * A phone shows roughly a third of a grid at a time and the median grid here is
 * nine columns, so reading anything on the right means the identifying column
 * has already scrolled away. That is the difference between a grid that is
 * cramped and one that cannot be used at all: values with no idea which record
 * they belong to.
 *
 * @param {Array}  cols  final column defs, synthetic columns first
 * @param {number} skip  how many leading synthetic columns to step over
 *                       (selection checkbox, row number) — those are already
 *                       pinned and are not what identifies a row
 */
export const pinFirstDataColumn = (cols, skip = 0) => {
  if (!Array.isArray(cols) || cols.length === 0) return cols;

  // Several grids pin deliberately. A second pinned column on a 390px screen
  // would leave almost nothing for the scrollable part, so defer to them.
  if (cols.some((c) => c && c.pinned)) return cols;

  if (skip >= cols.length) return cols;

  return cols.map((c, i) =>
    i === skip
      // Capped as well as floored: a 300px identity column would eat the screen.
      ? { ...c, pinned: 'left', minWidth: Math.min(c.minWidth || 120, 140) }
      : c
  );
};

export default pinFirstDataColumn;
